import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';

import { MaintenanceRequestService } from '../maintenance-request.service';
import { QuoteDialog } from '../quote-dialog/quote-dialog.component';

@Component({
  selector: 'instruction-dialog',
  templateUrl: './instruction-dialog.component.html'
})
export class InstructionDialogComponent {
  instruction: string;
  
  constructor(
    public dialogRef: MatDialogRef<QuoteDialog>,
    private readonly maintenanceService: MaintenanceRequestService,
    @Inject(MAT_DIALOG_DATA) public request: any // Accepts the Maintenance Request object as input
  ) {
    this.instruction = request.employee_instructions || '';
  }

  public confirm(): void {
    this.maintenanceService.updateEmployeeInstruction(this.request.id, this.instruction)
      .subscribe((result) => {
        let type: any = 'error';
        let message: string = 'Instruction could not be added';

        if (!isNullOrUndefined(result) && result.status == 200) {
          message = 'Instruction added successfully.'
          type = 'success';
        }

        swal({
          title: '',
          text: message,
          type: type,
          showCancelButton: false,
        }).then((result) => {
          this.dialogRef.close(this.instruction);
        });
      });
  }

  public close(): void {
    this.dialogRef.close();
  }
}